import React, {
    useContext, useEffect, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { isStandaloneApp } from 'app/utils/browser';
import Responsive, { Desktop } from 'app/components/Responsive';
import { DishAdLabel } from 'app/components/ui/Elements/DishAdLable/DishAdLabel';

import { DishImageShield } from 'app/components/ui/Elements/DishImageShield/DishImageShield';
import { useDishDetails } from 'app/components/MobileDishDetails';
import { isDesktop } from 'app/utils/resolution';
import { analyticService } from 'global/services';
import { set } from 'lodash';
import DishPortionCounter from '../../DishButtons/DishPortionCounter';
import DishButton, { OrderButton } from '../../DishButtons/DishButton';

import { DishMediaContent } from '../DishMediaContent';
import { DishTitle } from '../DishTitile';
import { DishDescription } from '../DishDescription';

import { NYGiftContext } from '../../NYGiftContext';
import { DishAddCheckbox } from '../../DishButtons/DishAddCheckbox';
import { BasketContext } from '../../BasketProvider';

export function DishLayoutWithToggle({
    index,
    id,
    isSoldOut,
    isWeightTimeHidden,
    partnersComment,
    portion,
    dishPortions,
    maxPortion,
    originalPriceWithStep,
    discountPriceWithStep,
    price,
    dishCountStep,
    imageUrl,
    imageUrlDesktop,
    time,
    hour,
    minutes,
    weightValue,
    weight,
    isCentered,
    buttonsDisabled,
    canChangePortionsCount,
    areDetailsEnabled: areDetailsEnabledProp,
    buttonText,
    buttonTextAction,
    linkUrl,
    imageLinkUrl,
    typeformWidgetId,
    isNovelty,
    colors,
    nutrition,
    isNutritionEnabled,
    isLastDish,
    slides,
    joinDishTitlesinMobile,
    title,
    description,
    hourText,
    minutesText,
    weightText,
    timeText,
    trackAddToBasket,
    v2Layout,
    giftWrapId = undefined,
    pageId,
    tags,
}) {
    const isEasterBox = id === '4443';
    const isBlueColor = colors === 'blue';
    const isPinkColor = colors === 'pink';
    const isCuttlefishColor = colors === 'cuttlefish';
    const isMarchgiftsPage = pageId === 'marchgifts';
    const isSquidgamePage = pageId === 'squid-game';
    const isUpcoming = Boolean(typeformWidgetId);
    const hasLabel = isSoldOut || isUpcoming || isNovelty;

    const [addButtonTapped, setAddButtonTapped] = useState(false);

    const { openDishDetails } = useDishDetails();

    const { updateBasket } = useContext(BasketContext);
    const areDetailsEnabled = id === 'ym' ? false : areDetailsEnabledProp;

    const rootClasses = cn({
        ny__dish__container: true,
        'ny__dish__container-v2': v2Layout,
        'light-dish': colors !== 'dark' && colors !== 'blue' && colors !== 'pink',
        'dark-dish': colors === 'dark',
        'blue-dish': isBlueColor,
        'pink-dish': isPinkColor,
        'cuttlefish-dish': isCuttlefishColor,
        centered: isCentered,
        'ny__dish__container--last': isLastDish,
        'ny__dish__container--has-label': hasLabel,
        'ny__dish__container--has-label-sold-out': isSoldOut,
        'ny__dish__container--has-label-upcoming': !isSoldOut && isUpcoming,
        'ny__dish__container--has-label-novelty': !isSoldOut && isNovelty,
        'ny__dish__container--without-details': !areDetailsEnabled,
        [pageId]: true,
    });

    const cardSlides = slides.filter((s) => s.placement === 'card');
    const containerProps = {
        'data-id': id,
        id: `dish_${id}`,
    };

    const textContainerProps = {};

    if (id !== 'ym') {
        if (cardSlides.length === 0) {
            containerProps['data-toggle-details-id'] = id;
        } else {
            textContainerProps['data-toggle-details-id'] = id;
        }
    }

    /* FRNT-3400 NY2024 ПОДАРОЧНЫЙ КОСТЫЛЬ */
    const {
        isGiftItem,
        getItemsListById,
    } = useContext(NYGiftContext);

    const portionWithGift = useMemo(() => {
        if (isGiftItem(id)) {
            const { itemsList } = getItemsListById(id);
            return itemsList.length;
        }
        return portion;
    }, [portion, isGiftItem, id, getItemsListById]);

    const squidgameDishClickTracker = () => {
        if (isSquidgamePage) {
            analyticService.push({
                eventName: 'Squid_game_Dish_Click',
                dish_id: id,
                dish_name: title,
            });
        }
    };

    const handleClickAddDishByCheckbox = () => {
        if (portionWithGift > 0) {
            setAddButtonTapped(false);
            updateBasket({
                dishId: id,
                portions: 0,
            });
            return;
        }
        setAddButtonTapped(true);
        updateBasket({
            dishId: id,
            portions: dishPortions.length > 0 ? dishPortions[0] : 0,
        });
    };

    useEffect(
        () => {
            setAddButtonTapped(portionWithGift > 0);
        },
        [portionWithGift],
    );

    // const { originalPriceWithGift, discountPriceWithGift, priceWithGift } = useMemo(() => {
    //     if (giftWrapId) {
    //         const { isGiftItemSelected, name } = getItemsListById(id);
    //         if (name === 'cantucci') {
    //             return {
    //                 originalPriceWithGift: isGiftItemSelected ? originalPriceWithStep : Number(originalPriceWithStep) - 100,
    //                 discountPriceWithGift: isGiftItemSelected ? discountPriceWithStep : Number(discountPriceWithStep) - 100,
    //                 priceWithGift: isGiftItemSelected ? price : Number(price) - 100,
    //             };
    //         }
    //         return {
    //             originalPriceWithGift: !isGiftItemSelected ? originalPriceWithStep : Number(originalPriceWithStep) + 100,
    //             discountPriceWithGift: !isGiftItemSelected ? discountPriceWithStep : Number(discountPriceWithStep) + 100,
    //             priceWithGift: !isGiftItemSelected ? price : Number(price) + 100,
    //         };
    //     }

    //     return {
    //         originalPriceWithGift: originalPriceWithStep,
    //         discountPriceWithGift: discountPriceWithStep,
    //         priceWithGift: price,
    //     };
    // }, [getItemsListById, giftWrapId, id, discountPriceWithStep, originalPriceWithStep, price]);

    const tagsString = tags?.map((tag) => tag.id)?.join(',');

    return (
        <div
            className={rootClasses}
            {...containerProps}
            role="none"
            onClick={(e) => {
                squidgameDishClickTracker();
                if (!isEasterBox) return;
                if (!isDesktop()) {
                    openDishDetails('4443', 'lp');
                    e.stopPropagation();
                }
            }}
        >
            <DishMediaContent
                id={id}
                useLazyLoading={index === 0}
                alt={title[0]}
                imageUrl={imageUrl}
                imageUrlDesktop={imageUrlDesktop}
                slides={cardSlides}
                additionalContent={(
                    <>
                        <DishAdLabel id={id} />
                        <DishImageShield
                            dishId={id}
                            isSoldOut={isSoldOut}
                            tagsString={tagsString}
                            realm="lp"
                        />
                        <div
                            className="ny__dish_checkbox_wrapper"
                            onClickCapture={(e) => {
                                handleClickAddDishByCheckbox();
                                e.stopPropagation();
                            }}
                            role="none"
                        >
                            <DishAddCheckbox show={addButtonTapped} />
                        </div>
                        {/* <div className="ny__dish__details-opener" {...textContainerProps} /> */}
                        {imageLinkUrl && (
                            <a
                                className="ny__dish__link-opener"
                                href={imageLinkUrl}
                                target={isStandaloneApp() ? '_self' : '_blank'}
                                rel="noopener noreferrer"
                            >
                                {imageLinkUrl}
                            </a>
                        )}
                    </>
                )}
            />

            <div className="ny__dish__bottom-container" {...textContainerProps}>
                <div>
                    <div className="ny__dish__desc-container">
                        <DishTitle
                            joinDishTitlesinMobile={joinDishTitlesinMobile}
                            title={title}
                            colors={colors}
                        />
                        <DishDescription
                            isEasterBox={isEasterBox}
                            areDetailsEnabled={areDetailsEnabled}
                            description={description}
                            partnersComment={partnersComment}
                            colors={colors}
                        />

                        {isNutritionEnabled && nutrition && (
                            <DishDescription
                                description={(
                                    <>
                                        На 1 готовую порцию:
                                        <Responsive mobile={<br />} desktop=" " />
                                        {weightValue}
                                        &nbsp;г |&nbsp;
                                        {Math.round((nutrition.calories.value * weightValue) / 100)}
                                        &nbsp;ккал
                                        | Б&nbsp;
                                        {Math.round((nutrition.protein.value * weightValue) / 100)}
                                        &nbsp;г
                                        | Ж&nbsp;
                                        {Math.round((nutrition.fat.value * weightValue) / 100)}
                                        &nbsp;г
                                        | У&nbsp;
                                        {Math.round((nutrition.carbohydrate.value * weightValue) / 100)}
                                        &nbsp;г
                                    </>
                                )}
                            />
                        )}
                    </div>
                </div>

                <div>
                    <div className="ny__dish__hr desktop-only" />

                    {!isMarchgiftsPage && ((weight || time || hour || minutes) && !isWeightTimeHidden && !isUpcoming) ? (
                        <div className="ny__dish__info-container without-icon">
                            {weight ? (
                                <span className="ny__dish__weight">
                                    <span className="num">{weight}</span>
                                    &nbsp;
                                    {weightText}
                                </span>
                            ) : null}
                            {time && (!hour || !minutes) ? (
                                <span className="ny__dish__cooking-time">
                                    {time !== ' ' && (
                                        <>
                                            <span className="num">{time}</span>
                                            &nbsp;
                                        </>
                                    )}
                                    {timeText}
                                </span>
                            ) : null}
                            {hour || minutes ? (
                                <>
                                    <span className="ny__dish__cooking-time">
                                        {hour !== ' ' && (
                                            <>
                                                <span className="num">{hour}</span>
                                                &nbsp;
                                            </>
                                        )}
                                        {hourText}
                                        &nbsp;
                                    </span>

                                    <span className="ny__dish__cooking-time">
                                        {minutes !== ' ' && (
                                            <>
                                                <span className="num">{minutes}</span>
                                                &nbsp;
                                            </>
                                        )}
                                        {minutesText}
                                    </span>
                                </>
                            ) : null}
                        </div>
                    ) : (
                        <Desktop>
                            <div className="ny__dish__info-container ny__dish__info-container--stub">&nbsp;</div>
                        </Desktop>
                    )}

                    <div data-dish-button>
                        {(buttonText) ? (
                            <OrderButton
                                text={buttonText}
                                linkUrl={linkUrl}
                                isOpenDetailsHandler={isUpcoming}
                            />
                        ) : (
                            canChangePortionsCount && !isSoldOut && !isUpcoming && (
                                <DishButton
                                    id={id}
                                    giftWrapId={giftWrapId}
                                    originalPriceWithStep={originalPriceWithStep}
                                    discountPriceWithStep={discountPriceWithStep}
                                    price={price}
                                    dishCountStep={dishCountStep}
                                    portion={portion}
                                    maxPortion={maxPortion}
                                    isInfoBlock
                                    onClickAddToBasket={trackAddToBasket}
                                    className="fullWidth"
                                    withToggle
                                />
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

DishLayoutWithToggle.propTypes = {
    id: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    giftWrapId: PropTypes.string,
};
